import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.ROUTER_BASE,
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      redirect: '/24mjwhys'
    },
    {
      path: '/24mjwhys',
      name: '24mjwhys',
      component: () => import('@/views/pages/index'),
      meta: {
        pageTitle: '民间文化艺术',
        keepAlive: true

      }
    },  
 

    {
      path: '/news/:subsets?/:school?',
      name: 'news',
      component: () => import('@/views/pages/news/index'),
      meta: {
        pageTitle: 'TA说',
        keepAlive: true

      }
    },
    {
      path: '/cultural/:subsets?/:school?',
      name: 'cultural',
      component: () => import('@/views/pages/news/cultural'),
      meta: {
        pageTitle: '相关文献',
        keepAlive: true

      }
    },
        {
      path: '/subsets/:school',
      name: 'subsets',
      component: () => import('@/views/pages/subsets/index'),
      meta: {
        pageTitle: '专题',
        keepAlive: true 
      }
    },
    {
      path: '/atlas/:subsets?/:school?',
      name: 'atlas',
      component: () => import('@/views/pages/subsets/atlas'),
      meta: {
        pageTitle: '图集',
        keepAlive: true 
      }
    },
    {
      path: '/dialect/:subsets?/:school?',
      name: 'dialect',
      component: () => import('@/views/pages/dialect'),
      meta: {
        pageTitle: '乡话',
        keepAlive: true
      }
    },
        {
      path: '/character/:subsets?/:school?',
      name: 'character',
      component: () => import('@/views/pages/character'),
      meta: {
        pageTitle: '人物',
        keepAlive: true

      }
    }, 

    {
      path: '/newsDetail/:code/:school?',
      component: () => import('@/views/pages/news/detail'),
      name: 'newsDetail',
      meta: { pageTitle: '资讯详情', icon: 'app', noCache: true, }
    },
    {
      path: '/skill/:subsets?/:school?',
      name: 'skill',
      component: () => import('@/views/pages/skill'),
      meta: {
        pageTitle: '技艺',
        keepAlive: true

      }
    },
    {
      path: '/sjcwDetail/:index',
      name: 'sjcwDetail',
      component: () => import('@/views/pages/pic_detail/sjcw'),
      meta: {
        pageTitle: '详情',
      }
    },


    {
      path: '/dnkcwDetail/:code/:school?/:className',
      name: 'dnkcwDetail',
      component: () => import('@/views/pages/pic_detail/dnkcw'),
      meta: {
        pageTitle: '详情',
      }
    },
    {
      path: '/pic_detail/:ocCode/:sortIndex/:teamCode/:ocName?/:searchSort',
      name: 'pic_detail',
      component: () => import('@/views/pages/pic_detail/index'),
      meta: {
        pageTitle: '视频详情'
      }
    },
    {
      path: '/img_detail/:school?/:ocCode/:sortIndex/:ocName?',
      name: 'img_detail',
      component: () =>
        import('@/views/pages/img_detail/index'),
      meta: {
        pageTitle: '图片详情'
      }
    },
    {
      path: '/Mooc/:subsets?/:school?',
      name: 'Mooc',
      component: () => import('@/views/pages/Mooc'),
      meta: {
        pageTitle: '慕课',
        keepAlive: true
      }
    },
    {
      path: '/zajmDetail/:ocCode/:type',
      name: 'zajmDetail',
      component: () => import('@/views/pages/pic_detail/zajm'),
      meta: {
        pageTitle: '详情',
       
      }
    },
 
    {
      path: '/villageDetail/:ocCode',
      name: 'villageDetail',
      component: () => import('@/views/pages/pic_detail/xcwh'),
      meta: {
        pageTitle: '我眼中的村晚详情',
        // keepAlive: true
      }
    },
    {
      path: '/resultview',
      name: 'resultview',
      component: () => import('@/views/pages/resultview'),
      meta: {
        pageTitle: '结果公示'
      }
    },
 


    {
      path: '/login',
      component: () => import('@/views/login/login'),
      name: 'login',
      meta: { pageTitle: '登录页', icon: 'app', noCache: true }
    },
    // -------------------------------后台--资讯-----------------------------
    {
      path: '/newsList',
      component: () => import('@/views/admin/newsList/news'),
      name: 'newsList',
      meta: { pageTitle: '活动快讯', icon: 'app', noCache: true }
    },
    {
      path: '/addNews',
      component: () => import('@/views/admin/newsList/add'),
      name: 'addNews',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/newsList' }
    },
    {
      path: '/editNews/:id',
      component: () => import('@/views/admin/newsList/edit'),
      name: 'editNews',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/newsList' }
    },
    {
      path: '/culturallist',
      component: () => import('@/views/admin/villList/list'),
      name: 'culturallist',
      meta: { pageTitle: '示范点风采', icon: 'app', noCache: true }
    },
    {
      path: '/addCultural',
      component: () => import('@/views/admin/villList/add'),
      name: 'addCultural',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/culturallist' }
    },
    {
      path: '/editCultural/:id',
      component: () => import('@/views/admin/villList/edit'),
      name: 'editCultural',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/culturallist' }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js